import { UserRoles } from '@abtasty/api-client';
import { detect } from 'detect-browser';

export const isSafari = () => {
  const browser = detect();
  return browser?.name === 'safari';
};

export const isFirefox = () => {
  const browser = detect();
  return browser?.name === 'firefox';
};

export const isIOS = () => {
  return /(iPad|iPhone|iPod)/.test(navigator.platform);
};

export const hasMinimumRole = (userRole: UserRoles, role: UserRoles) => {
  const AllAccessLevel = [UserRoles.viewer, UserRoles.creator, UserRoles.user, UserRoles.admin, UserRoles.superAdmin];
  return AllAccessLevel.indexOf(userRole) >= AllAccessLevel.indexOf(role);
};
